import { toast } from "react-hot-toast";
import { useEffect } from "react";

const CustomAlert = ({ errorMessage }) => {
  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
    } else {
      toast.success("")
    }
  }, [errorMessage]);
  return null;
};

export default CustomAlert;
